<template>
  <div class="single-video-with-context">
    <button
      @click.stop="$emit('close-video-player')"
      class="single-video-with-context__close"
    >
      <CloseIcon class="single-video-with-context__close--icon" />
    </button>
    <div
      v-show="!isComponentLoading"
      class="single-video-with-context__wrapper"
    >
      <VideoParentResult
        v-if="currentParent"
        :parent="currentParent"
        :parentType="video.parent_type"
      />
      <MediaDelegate
        class="single-video-with-context__media"
        v-if="currentParent"
        v-bind="{
          parentType: video.parent_type,
          content: { ...video, type: 'video', id: video.objectID },
          userCompletionStatus: 'unfinished', // Algolia doesn't have status of a video
          manualParent: currentParent,
        }"
        @is-loading="setIsLoading"
      />
    </div>
    <div
      v-show="isComponentLoading"
      class="single-video-with-context__spinner-wrapper"
    >
      <ActionLoader loaderClass="single-video-with-context__spinner" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import MediaDelegate from '@/components/media/MediaDelegate.vue'
import VideoParentResult from '@/components/search/VideoParentResult.vue'
import CloseIcon from '@/assets/icons/navigation/close_icon.svg'
import CONSTANTS from '@/constants'

export default {
  name: 'SingleVideoWithContext',
  components: {
    CloseIcon: { ...CloseIcon, name: 'CloseIcon' },
    ActionLoader,
    MediaDelegate,
    VideoParentResult,
  },
  props: {
    video: {
      type: Object,
      required: true,
    },
    parents: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState({
      isComponentLoading: state => state.app.isComponentLoading,
      profile: state => state.auth.userProfile,
      isImpersonating: state => state.admin.isImpersonating,
      course: state => state.courses.currentCourse,
    }),
    currentParent() {
      const parents = CONSTANTS.SEARCH.PARENTS
      return this.parents[parents[this.video.parent_type]][this.video.parent_id]
    },
  },
  methods: {
    setIsLoading(state) {
      this.$store.dispatch('app/setIsComponentLoading', state)
    },
  },
  destroyed() {
    this.$store.dispatch('content/resetContentState')
    document.querySelector('body').style.overflowY = 'visible'
  },
}
</script>

<style lang="scss" scoped>
.single-video-with-context {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  transition: opacity 0.3s ease;
  &__wrapper {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    top: 10%;
    margin: 0px auto;
    color: var(--white);
    @include tablet {
      max-width: 60vw;
      min-height: 60vh;
    }
  }
  &__media {
    width: 100%;
  }
  &__close {
    width: 50px;
    height: 50px;
    position: absolute;
    right: 10px;
    top: 10px;
    background: none;
    border: none;
    cursor: pointer;
    &:hover {
      .single-video__close--icon {
        fill: var(--orange);
      }
    }
    &--icon {
      fill: var(--white);
    }
  }
  &__spinner-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
